import { ReactComponent as IconChevron } from 'assets/icons/icon-chevron.svg';
import { ReactComponent as IconChecklists } from 'assets/icons/icon-document.svg';
import { ChevronWrapper, CopyWrapper } from 'components/alert/alert.styles';
import { H5 } from 'components/headings';
import Link from 'next/link';
import React, { FC, MouseEvent, useMemo } from 'react';
import styled from 'styled-components';
import { ReactComponent as IconBushfireWarningSystem } from '../../assets/icons/icon-bushfire-warning-system.svg';
import { ReactComponent as IconEmergencyWA } from '../../assets/icons/icon-emergencyWA.svg';
import { ReactComponent as IconFacebook } from '../../assets/icons/icon-facebook-colour.svg';
import { ReactComponent as IconFireDangerRatings } from '../../assets/icons/icon-fire-danger-ratings.svg';
import { ReactComponent as IconPhone } from '../../assets/icons/icon-phone.svg';
import { ReactComponent as IconConversation } from '../../assets/icons/icon-questions.svg';
import { ReactComponent as IconRadio } from '../../assets/icons/icon-radio.svg';
import {
  CardText,
  IconAlertWrapper,
  ToolsCardStyled,
  ToolsCardStyledNoHover,
} from './tools-card.styles';

interface Props {
  icon:
    | 'emergency'
    | 'facebook'
    | 'phone'
    | 'radio'
    | 'warning-system'
    | 'fire-danger-ratings'
    | 'conversation'
    | 'resource';
  title: string;
  description: string;
  href: string;
  handleClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const CardTextWrapper = styled(CopyWrapper)`
  text-align: left;
`;

// Switch statement that will determine what icon to show based on what props are passed in.
const ToolsCard: FC<Props> = ({
  icon,
  title,
  description,
  href,
  handleClick,
}) => {
  const getIcon = useMemo(() => {
    switch (icon) {
      case 'emergency':
        return <IconEmergencyWA style={{ height: '32px', width: '32px' }} />;
      case 'facebook':
        return <IconFacebook style={{ height: '32px', width: '32px' }} />;
      case 'phone':
        return <IconPhone style={{ height: '28px', width: '28px' }} />;
      case 'radio':
        return <IconRadio style={{ height: '36px', width: '36px' }} />;
      case 'warning-system':
        return (
          <IconBushfireWarningSystem
            style={{ height: '32px', width: '32px' }}
          />
        );
      case 'fire-danger-ratings':
        return (
          <IconFireDangerRatings
            style={{
              height: '40px',
              width: '40px',
            }}
          />
        );
      case 'conversation':
        return <IconConversation style={{ height: '32px', width: '32px' }} />;
      case 'resource':
        return <IconChecklists style={{ height: '26px', width: '26px' }} />;
    }
  }, [icon]);

  return (
    <>
      {/* If it's the phone card, which has no links, disable all pointer events and remove the chevron */}
      {icon === 'phone' ? (
        <Link href={href} passHref>
          <ToolsCardStyledNoHover as='a' target='_blank' onClick={handleClick}>
            <IconAlertWrapper>{getIcon}</IconAlertWrapper>
            <CardTextWrapper style={{ textAlign: 'left' }}>
              <H5 as='strong'>{title}</H5>
              <CardText>{description}</CardText>
            </CardTextWrapper>
          </ToolsCardStyledNoHover>
        </Link>
      ) : (
        <Link href={href} passHref>
          <ToolsCardStyled as='a' target='_blank' onClick={handleClick}>
            <IconAlertWrapper>{getIcon}</IconAlertWrapper>
            <CardTextWrapper style={{ textAlign: 'left' }}>
              <H5 as='strong'>{title}</H5>
              <CardText>{description}</CardText>
            </CardTextWrapper>
            <ChevronWrapper>
              <IconChevron aria-hidden />
            </ChevronWrapper>
          </ToolsCardStyled>
        </Link>
      )}
    </>
  );
};

export default ToolsCard;
